/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { FileRejection, useDropzone } from 'react-dropzone';
import { connect } from 'react-redux';

import { Toastify } from 'src/services';
import appConfig from 'src/appConfig';
import { Icon, Text, View } from '../common';
import { IRootState } from 'src/redux/rootReducer';
import './styles.scss';

const FileUpload: React.FC<Props> = ({ onChange }) => {
  const [myFiles, setMyFiles] = useState<File[]>([]);
  const [rejectFiles, setRejectFiles] = useState<FileRejection[]>([]);

  const onDrop = (acceptedFiles: File[], fileRejections: FileRejection[]) => {
    setMyFiles(acceptedFiles);
    setRejectFiles(fileRejections);
  };

  // List MIME can be found here:
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: 'image/jpg, image/jpeg, image/png, application/pdf',
    maxSize: appConfig.MAXIMUM_FILE_SIZE,
  });

  useEffect(() => {
    if (rejectFiles.length > 0) {
      rejectFiles.forEach(file => {
        const error = file.errors[0];
        Toastify.error(error.message);
      });
    }
  }, [rejectFiles]);

  useEffect(() => {
    if (myFiles.length > 0) onChange(myFiles);
  }, [myFiles]);

  // For more info about react dropzone follow:
  // https://react-dropzone.js.org/
  return (
    <View className="cmp-file-upload">
      <View {...getRootProps({ className: 'cmp-file-upload__body' })}>
        <input {...getInputProps()} />
        <View isRow align="center">
          <Icon name="ic_plus" className="mr-8" /> <Text>{'CLICK HERE TO UPLOAD FILE(S) OR DRAG & DROP HERE'}</Text>
        </View>
      </View>
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps & {
    onChange: (...args: any[]) => void;
  };

const mapStateToProps = (state: IRootState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(FileUpload);
